<template>
  <div class="pt-10 pb-5 component-div">
    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-if="componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined)"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
            <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
          </div>
        </b-col>
      </b-row>

      <b-row class="pl-45 pt-10">
        <b-form-textarea type="text" name="activityFormTextPreview" disabled rows="6" />
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            :class="isFieldDisabled ? 'disable-question' : ''"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-if="componentData.isSkippable"
            :class="isFieldDisabled ? 'disable-question' : ''"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <span v-if="hasFieldWarning" class="text-warning pl-5 fw-bold">{{ fieldWarningText }}</span>
          <span v-else-if="hasFieldError" class="text-danger pl-5 fw-bold">{{ fieldErrorText }}</span>
        </b-col>
      </b-row>

      <b-row class="mb-10 mt-5 pl-43" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-col cols="5" class="p-0">
          <b-form-input class="mb-0" type="email" name="activityFormTextEmail" v-model="componentData.answer" :disabled="isFieldDisabled" @input="onFieldChange" :class="{ 'is-danger': hasFieldError }" v-if="componentData.fieldType == 'email'" v-validate="!componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined) ? 'required|email' : 'email'" />
          <b-form-textarea class="mb-0" name="activityFormTextOpentext" v-model="componentData.answer" :disabled="isFieldDisabled" @input="onFieldOpenTextChange" :rows="componentData.numberOfLines" :class="{ 'is-danger': hasFieldError }" v-if="componentData.fieldType == 'opentext'" />
          <vue-tel-input class="mb-0" name="activityFormTextPhoneNumber" v-model="componentData.answer" :placeholder="translateToActiveLang('input_placeholder_phone_number', 'Enter a phone number')" :disabled="isFieldDisabled" :preferredCountries="['us']" :class="{ 'is-danger': hasFieldError }" v-if="componentData.fieldType == 'phonenumber'" @onInput="onInputTelephone"></vue-tel-input>

          <b-form-input class="mb-0" type="text" name="activityFormTextWebsite" v-model="componentData.answer" :disabled="isFieldDisabled" @input="onFieldChangeWebsite" :class="{ 'is-danger': hasFieldError }" v-if="componentData.fieldType == 'websiteurl'" v-validate="'required|url'" />
        </b-col>
        <b-col cols="7"> </b-col>
        <b-col cols="8"></b-col>
      </b-row>
      <div :class="isFieldDisabled ? 'disable-question' : ''">
        <span class="activity-form__clear pl-43" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label class="fs-12" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            {{ componentData.actualScore || showScore(componentData.skipScore) }}
          </div>
        </div>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col cols="10" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-if="componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined)"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
        </b-col>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div class="answers ml-16">{{ componentData.answer }}</div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
              <!-- <span v-if="componentData.excludeScore" class="ml-10">Score excluded from total</span> -->
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
            class="answers previous-value"
          >
            Previous value
          </div>
          <div>{{ componentData.previousAnswer }}</div>
          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
              <!-- <span v-if="componentData.excludeScore" class="ml-10">Score excluded from total</span> -->
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "activity-form-validated-entry-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: ""
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean
  },
  watch: {
    isFieldDisabled(val) {
      if (val === true) {
        this.resetField();
      }
    },
    hasFieldError(val) {
      this.componentData.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.componentData.fieldErrorText = val;
    },
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.validateInput();
      }
    }
  },
  mounted: function() {
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }
  },
  methods: {
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },

    validateInput() {
      this.$validator.validateAll().then(() => {
        this.validateOnBlank();
      });
    },
    resetField() {
      this.componentData.answer = undefined;
      setTimeout(() => {
        this.resetAllErrors();
        this.componentData.computedScore = 0;
        this.componentData.actualScore = 0;
      }, 10);
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.resetField();
      this.$emit("onClearAnswer", this.componentData);
    },
    onFieldOpenTextChange() {
      this.resetAllErrors();
      const specialFormat = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      const charFormat = /^[A-Za-z]+$/;
      const numberFormat = /[0-9]/;

      if (this.componentData.answer != undefined && this.componentData.answer.length > 0) {
        if (this.componentData.lettersAllowed) {
          if ((!this.componentData.numbersAllowed && numberFormat.test(this.componentData.answer)) || (!this.componentData.specialCharactersAllowed && specialFormat.test(this.componentData.answer))) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_allowed_letters", "Only [letters] are allowed.");
          } else if (!this.componentData.specialCharactersAllowed && specialFormat.test(this.componentData.answer)) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_allowed_letters_number", "Only [letters and numbers] are allowed.");
          } else if (!this.componentData.numbersAllowed && numberFormat.test(this.componentData.answer)) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_allowed_letters_special_char", "Only [letters and special characters] are allowed.");
          }
        }

        if (this.componentData.numbersAllowed) {
          if ((!this.componentData.lettersAllowed || this.componentData.lettersAllowed == undefined) && charFormat.test(this.componentData.answer) && !this.componentData.specialCharactersAllowed && specialFormat.test(this.componentData.answer)) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_allowed_numbers", "Only [numbers] are allowed.");
          } else if (!this.componentData.specialCharactersAllowed && specialFormat.test(this.componentData.answer)) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_allowed_letters_number", "Only [letters and numbers] are allowed.");
          } else if ((!this.componentData.lettersAllowed || this.componentData.lettersAllowed == undefined) && charFormat.test(this.componentData.answer)) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_allowed_number_special_char", "Only [numbers and special characters] are allowed.");
          }
        }

        if (this.componentData.specialCharactersAllowed) {
          if ((!this.componentData.lettersAllowed || this.componentData.lettersAllowed == undefined) && charFormat.test(this.componentData.answer) && !this.componentData.numbersAllowed && numberFormat.test(this.componentData.answer)) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_allowed_special_chars", "Only [special characters] are allowed.");
          } else if ((!this.componentData.lettersAllowed || this.componentData.lettersAllowed == undefined) && charFormat.test(this.componentData.answer)) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_allowed_number_special_char", "Only [numbers and special characters] are allowed.");
          } else if (!this.componentData.numbersAllowed && numberFormat.test(this.componentData.answer)) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_allowed_letters_special_char", "Only [letters and special characters] are allowed.");
          }
        }

        if (this.componentData.lettersAllowed || this.componentData.specialCharactersAllowed) {
          if (this.componentData.answer.length < this.componentData.minChars) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_min_char", "Response must be " + this.componentData.minChars + " characters or greater.", { MIN_CHAR_LIMIT: this.componentData.minChars });
          }

          if (this.componentData.answer.length > this.componentData.maxChars) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_max_char", "Response must be " + this.componentData.maxChars + " characters or less including spaces.", { MAX_CHAR_LIMIT: this.componentData.maxChars });
          }
        }
      }
      this.onAnswerChange();
    },
    onFieldChange() {
      this.resetAllErrors();
      this.validateOnBlank();
      if (this.errors.items.length > 0 && this.errors.has("activityFormTextEmail")) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_valid_email", "Enter a valid email address.");
      }
      this.onAnswerChange();
    },
    onFieldChangeWebsite() {
      this.resetAllErrors();
      const websiteURL = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;

      if (!websiteURL.test(this.componentData.answer)) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_valid_website", "Enter a valid website address without spaces such as 'http://www.example.com'.");
      }
      this.onAnswerChange();
    },
    onInputTelephone({ isValid }) {
      this.resetAllErrors();
      if (isValid) {
        this.hasFieldError = false;
      } else {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_valid_phone", "Enter a valid phone number in the format '+national code-area code-local exchange-local number' such as <+1-800-555-0120>.");
      }
      this.onAnswerChange();
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },
    validateOnBlank() {
      let { isSkippable, answer, dataEditChecks } = this.componentData;
      this.componentData.dataChecks = [];
      if (dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "NOT_BLANK" && (answer === "undefined" || answer === "")) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `This field is required.`;
              softDataCheck = true;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              return false;
            }
          } else {
            if (dataEditChecks[k].type == "NOT_BLANK" && (answer === "undefined" || answer === "")) {
              this.hasFieldError = true;
              this.fieldErrorText = `This field is required.`;
              isSkippable = false;
              return false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      if (!isSkippable && (answer === "" || typeof answer === "undefined" || answer === null)) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
      }
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.componentData.computedScore = this.componentData.score;
        this.componentData.actualScore = this.componentData.score;
        this.$emit("onAnswerChange", this.componentData);
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
</style>
